import React, { useState } from 'react';
import { TextField, Button, Box, CircularProgress } from '@mui/material';
import MarkdownEditor from './RecetaMarkdown/markdownEditor';

const TemplateRecetaForm = ({ onSubmit, isSaving }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
  });

  const [errors, setErrors] = useState({
    nombre: false,
    descripcion: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: value.trim() === '',
    }));
  };

  const handleSubmit = (e) => {
    const isFormValid = formData.nombre.trim() !== '' && formData.descripcion.trim() !== '';

    e.preventDefault();
    if (isFormValid) {
      onSubmit(formData);
      setFormData({
        nombre: '',
        descripcion: '',
      });
    }
  };

  return (
    <>
    {isSaving ? (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%',
        gap: 2,
        margin: '0px 10px 15px 10px',
        mt: 5,
        height: '530px',      // Limita altura total del form al 80% de la ventana
        overflow: 'hidden',
       }}>
        <CircularProgress />
      </Box>
    ) : (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        margin: '0px 10px 15px 10px',
        mt: 5,
        maxHeight: '80vh',      // Limita altura total del form al 80% de la ventana
        overflow: 'hidden',    // Evita overflow externo
      }}
    >
      <TextField
        label="Nombre"
        name="nombre"
        value={formData.nombre}
        onChange={handleChange}
        error={errors.nombre}
        helperText={errors.nombre ? 'Este campo es obligatorio' : ''}
        required
      />

      {/* Contenedor para el editor con scroll interno */}
      <Box
        sx={{
          flexGrow: 1,           // Ocupa espacio disponible
          minHeight: 200,        // Altura mínima para el editor
          maxHeight: 400,        // Altura máxima para el editor
          overflowY: 'auto',     // Scroll vertical cuando crezca contenido
          border: '1px solid #ccc',
          borderRadius: 1,
          p: 1,
        }}
      >
        <MarkdownEditor
          initialValue={formData.descripcion}
          onClickFunction={() => {}}
          onChange={(value) => {
            setFormData((prev) => ({
              ...prev,
              descripcion: value,
            }));
          }}
          showEditOptions={true}
        />
      </Box>

      <Button
        type="submit"
        variant="contained"
        color="primary"
        sx={{
          backgroundColor: '#148f9f',
          '&:hover': {
            backgroundColor: '#148f9f',
          },
        }}
        disabled={isSaving}
      >
          Guardar
      </Button>
    </Box>
    )}
    </>
  );
};

export default TemplateRecetaForm;
